import { render, staticRenderFns } from "./BranchesWarehouses.vue?vue&type=template&id=18ffc956&scoped=true&lang=pug&"
import script from "./BranchesWarehouses.vue?vue&type=script&lang=js&"
export * from "./BranchesWarehouses.vue?vue&type=script&lang=js&"
import style0 from "./BranchesWarehouses.vue?vue&type=style&index=0&id=18ffc956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ffc956",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
